/**
 * Names the browser listens for on the command center. The API holds the same
 * literals in app/Support/CommandCenterRealtimeNames.php and its test reads this
 * file, so renaming one side without the other fails the API suite. The leading
 * dot on the event tells Echo the name is complete (no namespace prefix).
 */
export const COMMAND_CENTER_CHANNEL_PREFIX = "tenant.";
export const COMMAND_CENTER_PRESENCE_PREFIX = "presence-tenant.";
export const COMMAND_CENTER_CHANNEL_SUFFIX = ".command-center";
export const COMMAND_CENTER_MESSAGE_POSTED_EVENT = ".command-center.message.posted";
export const COMMAND_CENTER_MESSAGE_UPDATED_EVENT = ".command-center.message.updated";
export const COMMAND_CENTER_MENTION_EVENT = ".command-center.mention";
export const COMMAND_CENTER_USER_CHANNEL_PREFIX = "App.Models.User.";

/** The private channel `routes/channels.php` authorizes per user; Laravel broadcasts the mention there. */
export function commandCenterUserChannelName(userId: string): string {
  return `${COMMAND_CENTER_USER_CHANNEL_PREFIX}${userId}`;
}

export function commandCenterChannelName(tenantId: string): string {
  return `${COMMAND_CENTER_CHANNEL_PREFIX}${tenantId}${COMMAND_CENTER_CHANNEL_SUFFIX}`;
}

export function commandCenterPresenceChannelName(tenantId: string): string {
  return `${COMMAND_CENTER_PRESENCE_PREFIX}${tenantId}${COMMAND_CENTER_CHANNEL_SUFFIX}`;
}

export const COMMAND_CENTER_MESSAGES_QUERY_KEY = ["command-center", "messages"] as const;
export const COMMAND_CENTER_PARTICIPANTS_QUERY_KEY = ["command-center", "participants"] as const;
export const COMMAND_CENTER_POLL_MS = 30_000;
